import React from 'react';

export interface LoadingChildrenBoxProps {
  children: React.ReactElement;
  loading: boolean;
  loadingElement: React.ReactElement;
}

export const LoadingChildrenBox = (props: LoadingChildrenBoxProps) => {
  if (props.loading) {
    return props.loadingElement;
  }
  return props.children;
};
